const ACTION_CANCEL_BOOKING = '_cancel_booking'
const ACTION_CANCEL_BOOKING_LATE = '_cancel_booking_late'
const ACTION_GET_BOOKING_EDIT_FORM = '_get_booking_edit_form'
const ACTION_UPDATE_BOOKING_EDIT_FORM = '_refresh_booking_edit_form'
const ACTION_SAVE_BOOKING = '_save_booking'
const FORM_ID = 'edit-booking-form'
const ACTION_GET_EDIT_BOOKING_COMMENT_POPUP = '_get_edit_booking_comment_popup'
const ACTION_UPDATE_BOOKING_COMMENT = '_update_booking_comment'

extend_vue = new NorseVue({
    data: {
        exam_event: '',
        showInvoice: '',
        showCertificateNumber: '',

        dialog: false,
    },
    methods: {
        cancelBooking() {
            this.dialog = false
            const action = new Action(ACTION_CANCEL_BOOKING)
            action.performAction({}).then((response) => {
                let redirectUrl = response.data['redirect_url']
                this.redirect(redirectUrl)
            })
        },
        cancelBookingLate() {
            this.dialog = false
            const action = new Action(ACTION_CANCEL_BOOKING_LATE)
            action.performAction({}).then((response) => {
                let redirectUrl = response.data['redirect_url']
                this.redirect(redirectUrl)
            })
        },
        updateBookingForm() {
            this.$nextTick(() => {
                let form = document.getElementById(FORM_ID)
                const action = new Action(ACTION_UPDATE_BOOKING_EDIT_FORM)
                action.performAction(form).then((response) => {
                    EventBus.$emit('render-template', response.data)
                })
            })
        },
        saveBooking(evn) {
            this.$nextTick(() => {
                const action = new Action(ACTION_SAVE_BOOKING)
                action.enableManualCatch()
                action.performAction(evn.target).then((response) => {
                    let redirectUrl = response.data['redirect_url']
                    this.redirect(redirectUrl)
                }).catch((error) => {
                    if (error instanceof HTMLBadRequestError) {
                        EventBus.$emit('render-template', error.html_content)
                        return
                    }

                    ErrorHandler.processError(error)
                })
            })
        },
        getEditBookingCommentPopup() {
            const action = new Action(ACTION_GET_EDIT_BOOKING_COMMENT_POPUP)
            action.performAction({}).then((response) => {
                let actions = {
                    updateBookingComment: this.updateBookingComment,
                }
                EventBus.$emit('open-popup', {content: response.data, actions: actions})
            })
        },
        updateBookingComment() {
            let customer_comment = document.getElementById('id_customer_comment').value
            const action = new Action(ACTION_UPDATE_BOOKING_COMMENT)
            action.performAction({'customer_comment': customer_comment}).then((response) => {
                let msg = response.data.message
                if (msg) {
                    app.showSuccessMessage(msg)
                }
                EventBus.$emit('close-popup')
                document.getElementById('comment_id').innerText = response.data.customer_comment

            })
        },
        initView() {
            const action = new Action(ACTION_GET_BOOKING_EDIT_FORM)
            action.performAction().then((response) => {
                let actions = {
                    updateBookingForm: this.updateBookingForm,
                    saveBooking: this.saveBooking,
                }
                EventBus.$emit('create-template', {content: response.data, actions: actions})
            })
        },
    },
    created() {
        EventBus.$on('input-updated', this.updateBookingForm)
    },
    mounted() {
        this.initView()
    }
})